import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {}

export interface UserInitialState {
  value: User
}

const initialState: UserInitialState = {
  value: {},
};

export const userSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    addUserData: (state, action: PayloadAction<User>) => {
      state.value = action.payload;
    },
  },
});

export const { addUserData } = userSlice.actions;

export default userSlice.reducer;
